<div class="tag" [ngClass]="type">
  <p>{{text}}</p>
  <img *ngIf="status" class="margin-left-8" [alt]="status" [src]="tagStatusImage">
</div>
